//import region
import { useEffect, useState } from 'react';

// bootstrap
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';

// redux
import { resetUserStatus, selectUserDb, updateUserDb } from '_redux/slices/main-screen/user';
import { selectAirlineSelectedAirport, setAirlineSelectedAirport, } from '_redux/slices/prm-bookings/bookings';
import { useDispatch, useSelector, } from 'react-redux';
//end region
const AirlineAirportSelector = (props) => {
   
    // reset user status on render
    useEffect(() => {
        dispatch(resetUserStatus());
    }, []);

    //#region redux + states
    const dispatch = useDispatch();
    const userDb = useSelector(selectUserDb);
    const selectedAirport = useSelector(selectAirlineSelectedAirport);

    // local states
    const [iata, setIata] = useState('')
    const [list, setList] = useState([])    
    const [errors, setErrors] = useState('')
    //#endregion

    //#region components

    const AirportButton = (props) => {
        return (
            <Button
                onClick={props.onClick}
                variant={props.variant}
                style={{
                    marginTop:6, marginBottom:6, width:300
                }}>{props.title}  
            </Button>   
        )
    }

    const ColList = (props) => {
        return (
        <Col xs={3}>
            <div style={{marginTop:props.marginTop}} />
            {
                userDb && userDb.airports ? 
                    <ListGroup>
                    {
                        userDb.airports.map((airport, index)=>{
                            if(index >= props.start && index <= props.end){
                                return (
                                    <AirportButton title={airport} variant={airport == selectedAirport ? 'primary' : 'outline-primary'} onClick={()=>{handleSelection(airport)}} />
                                )
                            }
                        })
                    }
                    </ListGroup>
                : ''
            }
        </Col>
        )
    }
    //#endregion

    // set local list based on user db list
    useEffect(() => {
        if(userDb){
            if(userDb.airports){
                // set local list to be the same as db list
                setList(userDb.airports);
            }
        }
    }, [userDb]);

    

    // set selected iata
    const handleSelection = (airport) => {
        dispatch(setAirlineSelectedAirport(airport))
    }

    // delete iata
    const handleDelete = (airport) => {
        // delete selected airport
        let tempList = list.filter(e => e !== selectedAirport)
        dispatch(updateUserDb({...userDb, airports:tempList}))
        if(list.length > 0){dispatch(setAirlineSelectedAirport(list[0]))}
    }

    // add iata to list
    const handleAdd = () => {

        function hasNumber(myString) {
            return /\d/.test(myString);
        }

        if(iata.length != 3){
            setErrors('IATA Codes must only be three letters long')
        }
        else if(hasNumber(iata)){
            setErrors('IATA Codes must only be made up of letters')
        }
        else if(list.length == 36){
            setErrors('Maximum number of IATAs saved')
        }
        else if(list.includes(iata)){
            setErrors('This IATA has already been saved')
        }
        else {
            // add to list
            setErrors('')
            let tempList = [...list, iata.toLocaleUpperCase()]
            dispatch(updateUserDb({...userDb, airports:tempList}))
        }
    }

    return (
        <>
        {/* List of IATA's */}
        <Row>
            <ColList start={0} end={8} />
            <ColList start={8} end={16} />
            <ColList start={16} end={24} />
            <ColList start={24} end={32} />
        </Row>

        {/* Buttons for Adding, Delete and Done */}
        <Row>
            <Col xs={3}>
                <Form.Control className='mt-3' onChange={(e) => {setIata(e.target.value)}} type="name" placeholder="Airport IATA Code" style={{ borderColor:errors.length > 0 ? 'red' : ''}} value={iata} />
                {
                    errors.length > 0 &&
                        <p style={{color:'red', fontSize:12}}>{errors}</p>
                }
            </Col>
            <Col xs={6}>
                <Button onClick={handleAdd} variant={"outline-primary"} style={{width:100}} className="mt-3">Add IATA</Button>
            </Col>
            <Col xs={1}>
                <Button onClick={()=>{handleDelete()}} variant={"danger"} style={{width:100}} className="mt-3">Delete</Button>
            </Col>
            <Col xs={1}>
                <Button onClick={()=>{props.close()}} variant={"primary"} style={{width:100}} className="mt-3">Done</Button>
            </Col>
        </Row>
        </>
    )
};

export default AirlineAirportSelector;